import React from 'react';

var MobilePhone = function MobilePhone(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M8.83 5a.83.83 0 0 0-.83.83v12.34c0 .458.372.83.83.83h6.34a.83.83 0 0 0 .83-.83V5.83a.83.83 0 0 0-.83-.83H8.83zm0-2h6.34A2.83 2.83 0 0 1 18 5.83v12.34A2.83 2.83 0 0 1 15.17 21H8.83A2.83 2.83 0 0 1 6 18.17V5.83A2.83 2.83 0 0 1 8.83 3zM7 8V6h10v2H7zm0 10v-2h10v2H7z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

MobilePhone.defaultProps = {
  role: "img",
  viewBox: "0 0 24 24"
};
import iconHandler from './hoc';
export { MobilePhone as icon };
export default iconHandler(MobilePhone);


//////////////////
// WEBPACK FOOTER
// ./~/@jsluna/icons/dist/MobilePhone.js
// module id = 613
// module chunks = 0